<template>
  <div style="background-color: #F9FBFD;">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide blue-slide">
          <div class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s" swiper-animate-delay="3s">
            <img src="../../assets/banner2.png" alt="">
          </div>
        </div>
        <div class="swiper-slide red-slide">
          <div class="ounceInLeft" swiper-animate-duration="0.5s"
            swiper-animate-delay="3s">
            <img src="../../assets/banner1.png" alt="">
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <!--分页器。如果放置在swiper外面，需要自定义样式。-->

    </div>
    <div class="w">
      <div class="news-information">
        <div class="news-information-title">新闻资讯/NEWS</div>
        <div class="news-information-box">
          <div class="news-information-box-title">
            <div class="news-information-box-title-item" v-for="(item, key) in queryInfolist" :key="key"
              @click="godetail(item)">
              <div class="news-information-box-title-item-img">
                <el-image style="width: 207px; height: 88px;" :src="item.imageUrl" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="news-information-box-title-item-box">
                <span>{{item.title}}</span>
                <div>
                  <span class="news-information-box-title-item-box-button" v-if="item.type==1">新闻资讯</span>
                  <span class="news-information-box-title-item-box-button" v-if="item.type==2">学术指导</span>
                  <span class="news-information-box-title-item-box-button" v-if="item.type==3">活动通知</span>
                </div>
                <span>{{item.publishTime}}</span>
              </div>
            </div>


          </div>
          <div class="news-information-box-box">
            <video src="https://file.zhihuiyijiao.com/public/guanwang/guanwangvideo.mp4" style="width: 100%;"
              :controls="true"></video>
          </div>
        </div>
        <div class="news-information-more" @click="lookmore">
          查看更多
        </div>
      </div>
    </div>
    <div class="news-information-title">医教方案/Medical Education Program</div>
    <div class="swiper-container" style="height: 1001px;">
      <div class="swiper-wrapper">
        <div class="swiper-slide grey-slide">
          <div class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s" swiper-animate-delay="0.3s">
            <div class="news-content">
              <div class="news-content-img">
                <img src="../../assets/tongc.png" alt="">
              </div>
              <div class="news-information-title">同侪互评</div>
              <div class="news-content-box">
                同侪互评训练系统基于微信小程序开发，内置大量评分表，并且支持用户自己上传评分表，同学之间通过扫一扫即可实现面对面自由评分，学习训练项相关资源。通过这种方式满足同学间开展互助学习、互助训练的需要，肯定成绩、找出不足，促进同侪相互提高。极大提高了同侪训练热情，同时也极大降低了指导教师的工作量。
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide grey-slide">
          <div class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s" swiper-animate-delay="0.3s">
            <div class="news-content">
              <div class="news-content-img1">
                <img src="../../assets/mas.png" alt="">
              </div>
              <div class="news-information-title">码上评</div>
              <div class="news-content-box">
                码上评管理系统是通过信息化方式进行在线技能测评，系统支持线下扫码评、线上实时评、日常作业评三种形式。教师可随时发起码上评任务，学生通过手机完成任务，邀请教师进行评分。解决了教师布置作业难，任务追溯慢，评价管理繁等实际问题。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import 'swiper/dist/js/swiper'
  import 'swiper/dist/css/swiper.css'
  import Swiper from "swiper"
  export default {
    data() {
      return {
        fit: 'fill',
        queryInfo: {
          pageNum: 1,
          pageSize: 3,
          type: 1,
          status: 2
        },
        queryInfolist: []
      }
    },


    watch: {

    },
    created() {
      this.getofficialnewslist()
    },
    methods: {
      lookmore() {
        this.$router.push({
          path: '/News',
          query: {
            place: 0
          }
        })
      },
      async getofficialnewslist() {

        let res = await this.$Http.officialnewsall()
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist = res.data.data.list
      },
      godetail(item) {
        if(item.type == 1) {
          this.$router.push({
            path: '/News',
            query: {
              place: 3,
              placeid: item.id
            }
          })
        } else if(item.type == 2) {
          this.$router.push({
            path: '/News',
            query: {
              place: 5,
              placeid: item.id
            }
          })

        } else {
          this.$router.push({
            path: '/News',
            query: {
              place: 4,
              placeid: item.id
            }
          })
        }

      }

    },
    mounted() {
      new Swiper('.swiper-container', {
        direction: 'horizontal', // 垂直切换选项
        mousewheel: true, //滚轮
		autoplay:2500,
        // autoplay: true,
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 分页器可以点击
        },
      })
    },
  }
</script>
<style lang="less" scoped>
  .grey-slide {
    // background: #F0F3F9;
  }

  .blue-slide {
    // background: #4390EE;
  }

  .red-slide {
    // background: #CA4040;
  }

  .orange-slide {
    background: #FF8604;
  }

  .swiper-slide {
    width: 100%;

    img {
      width: 100%;
    }
  }




  .swiper-container {
    width: 100%;
  }

  .swiper-pagination /deep/ .swiper-pagination-bullet-active {
    background-color: #8693A4;
    width: 33px;
    border-radius: 20px;
  }

  .news-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .news-content-img {
    margin-top: 90px;
    width: 540px;
    height: 540px;
    margin-bottom: 90px;
  }

  .news-content-img1 {
    margin-top: 90px;
    width: 540px;
    height: 540px;
    margin-bottom: 90px;
  }


  .news-content-box {
    width: 914px;
    font-size: 16px;
    text-align: center;
    color: #8693A4;
    line-height: 42px;
    margin-top: 16px;
  }


  .w {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
  }

  .news-information {
    margin-top: 80px;
    width: 100%;
  }

  .news-information-title {
    width: 100%;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
  }

  .news-information-box {
    margin-top: 48px;
    width: 100%;
    padding: 24px 20px;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    align-items: center;
  }

  .news-information-box-title {
    width: 610px;
    overflow: hidden;
  }

  .news-information-box-title-item {
    display: flex;
    margin: 2px 0 14px;
    cursor: pointer;
  }

  .news-information-box-title-item:nth-child(3) {
    display: flex;
    margin-bottom: 0;
  }

  .news-information-box-title-item-img {
    width: 207px;
    height: 88px;
    display: flex;
    justify-content: center;

    img {
      height: 100%;
    }
  }

  /deep/ .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 128px;
    }
  }

  .news-information-box-title-item-box {
    padding: 3px 14px;
    width: 403px;
    height: 88px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .news-information-box-title-item-box span:nth-child(1) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 16px;
    font-weight: normal;
    color: #395172;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .news-information-box-title-item-box-button {
    display: inline-block;
    padding: 2px 5px;
    background: rgba(134, 147, 164, 0.1);
    font-size: 12px !important;
    border-radius: 2px;
    color: #8693A4 !important;
  }

  .news-information-box-title-item-box span:nth-child(3) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 14px;
    font-weight: normal;
    color: #8693A4;
  }

  .news-information-box-box {
    width: 550px;
    background-color: #DEE3EB;
  }

  .news-information-more {
    width: 136px;
    height: 48px;
    background: #1A7BFC;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 48px auto 80px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
  }
</style>
